import React from 'react';

export default function PantryItemCard(props) {
  return (
    <div className="PantryItemCard">
      <img src={props.img} alt="Not available"/>
      <div className="title">{props.title}</div>
      <div className="qty">{props.qty}</div>
    </div>

  );
}